export class socialSharing {
	constructor(element, settings) {
		this.defaults = {
			kind: null, // null autodetect the type of the share. { 'facebook', 'twitter', 'telegram', 'whatsapp' }
			url: null, // autodetect the url
			// Twitter only
			title: "",
			suffix: "",
		};
		this.options = Object.assign({}, this.defaults, settings);
		this.button = element;
		if (!this.options.url) {
			this.options.url = encodeURIComponent(window.location.href.split("?")[0]);
		}

		if (!this.options.kind) {
			this.options.kind = autodetect_share_type(button);
		}

		if (!this.options.title) {
			this.options.title = document.title;
		}

		if (this.options.title) {
			this.options.title = encodeURIComponent(this.options.title);
		}

		if (this.options.suffix) {
			this.options.suffix = encodeURIComponent(this.options.suffix);
		}

		this.button.addEventListener("click", (event) => {
			event.preventDefault();
			event.stopImmediatePropagation();
			if (this.options.kind === "facebook") {
				const url = `https://www.facebook.com/sharer/sharer.php?u=${this.options.url}`;
				this.openPopup(url, "facebook_share", 600, 500);
			} else if (this.options.kind === "x") {
				const url = `https://twitter.com/intent/tweet?text=${this.options.title} ${this.options.url} ${this.options.suffix}`;
				this.openPopup(url, "x_share", 600, 500);
			} else if (this.options.kind === "telegram") {
				const url = `https://telegram.me/share/url?url=${this.options.url}&text=${this.options.title}`;
				this.openPopup(url, "telegram_share", 600, 500);
			} else if (this.options.kind === "whatsapp") {
				const url = `https://api.whatsapp.com/send?text=${this.options.title} ${this.options.url}`;
				this.openPopup(url, "whatsapp_share", 600, 500);
			}
		});
	}

	openPopup(url, winId, width, height) {
		const left = Math.round(screen.width / 2 - width / 2);
		let top = 0;
		if (screen.height > height) {
			top = Math.round(screen.height / 3 - height / 2);
		}
		const popup_options = `left=${left},top=${top},width=${width},height=${height},personalbar=0,toolbar=0,scrollbars=1,resizable=1`;
		const win = window.open(url, winId, popup_options);
		if (!win) {
			location.href = url;
			return;
		}
		win.focus();
		return win;
	}
}

export function mbSocialSharing(element) {
	if (typeof navigator.share === "function") {
		navigator.share({
			text: element.dataset.text,
			url: window.location.href,
		});
	} else {
		element.classList.add("d-none");
		const shareDiv = document.querySelector("#_social-share");
		if (shareDiv) shareDiv.classList.replace("d-none", "d-flex");
	}
}
